import React, { Component } from "react";
import { logout } from "../../../lib/logout.js";
import commonFunction from "../../../lib/utils/common.js";
import { getProfileData } from "../../../lib/myProfile.js";
import { it } from "date-fns/locale";
import Link from "next/link.js";

class MobileHeader extends Component {
  handleLogout = () => {
    this.setState({ showLogoutPopup: true, sidebarOpen: false });
    logout()
      .then((responseJSON) => {
        if (
          responseJSON.status === true ||
          responseJSON.message === "Logout successfull"
        ) {
          // Optionally clear local state or user info here
          window.location.reload();
        }
      })
      .catch((err) => { });
  };
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      showLoginSheet: false,
      selectedMenuKey: null,
      isClosing: false,
      showLogoutPopup: false,
      displayName: "",
    };
    this.sidebarRef = React.createRef();
    this.loginSheetRef = React.createRef();
  }

  openSidebar = () => {
    this.setState({ sidebarOpen: true });
  };

  closeSidebar = () => {
    this.setState({ isClosing: true });
    setTimeout(() => {
      this.setState({ sidebarOpen: false, isClosing: false });
    }, 300);
  };

  handleOutsideClick = (e) => {
    if (
      this.state.sidebarOpen &&
      this.sidebarRef.current &&
      !this.sidebarRef.current.contains(e.target)
    ) {
      this.closeSidebar();
    }
  };

  handleLoginRegisterClick = (e) => {
    e.stopPropagation();
    this.setState({ showLoginSheet: true, sidebarOpen: true });
  };

  closeLoginSheet = () => {
    this.setState({ showLoginSheet: false });
  };

  handleLoginSheetOutsideClick = (e) => {
    if (
      this.state.showLoginSheet &&
      this.loginSheetRef.current &&
      !this.loginSheetRef.current.contains(e.target)
    ) {
      this.closeLoginSheet();
    }
  };

  handleLoginSheetAction = (action) => {
    this.closeLoginSheet();

    if (action === "login") {
      this.props?.data?.onClickHeaderLogin("LoginWithMobile");
    } else if (action === "Vendor_login") {
      this.props?.data?.onClickHeaderLogin("vendor_login",'vendor_login');
    } else if (action === "register") {
      this.props?.data?.onClickHeaderLogin("", "Register");
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
    document.addEventListener("mousedown", this.handleLoginSheetOutsideClick);
    if (this.props?.data?.user?.accessToken) {
      const siteid = this.props?.data?.site_id;
      const accessToken = this.props?.data?.user?.accessToken;
      getProfileData({ siteid, accessToken }).then((data) => {
        const profile = data?.data?.data[0];
        this.setState({ displayName: profile?.display_name || "" });
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
    document.removeEventListener(
      "mousedown",
      this.handleLoginSheetOutsideClick
    );
  }
  handleImageError = (event) => {
    event.target.onerror = null;
    event.target.src = 'images/userplaceholder.svg';
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.sidebarOpen !== prevState.sidebarOpen) {
      if (this.state.sidebarOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
  }

  render() {
    const rgType = this.props?.data?.user?.rg_type;
    const isMobile = this.props.data?.isMobile;
    // const validPaths = ["/registration", "/progress", "/vendor", "/myprofile"];
    // const pathname = validPaths.includes(window.location.pathname);
    const validPaths = ["/registration", "/progress", "/vendor", "/myprofile", "/vendorsubscription", "/vendorreview"];
    const pathOnly = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);

    let pathname = validPaths.includes(pathOnly);

    // special case → if /myprofile?activeTab=dashboard, override to false
    if (
      pathOnly === "/myprofile" &&
      (!searchParams.has("activeTab") ||
        searchParams.get("activeTab") === "dashboard")
    ) {
      pathname = false;
    }

    const styles = this.props.data.cssfile;
    const userTypes = [
      { role: "Tour Master", icon: "te_Tour_Master_user.svg" },
      { role: "Traveler", icon: "te_Profile.svg" },
      { role: "Vendor", icon: "te_Vendor.svg" },
    ];
    const sidebarMenu = [
      { key: "dashboard", label: "Dashboard", icon: "te_pr_Dashboard.svg" },
      { key: "profile", label: "Profile", icon: "te_pr_Profile.svg" },
      { key: "bookings", label: "Bookings", icon: "te_pr_Booking.svg" },
      {
        key: "subscription",
        label: "Subscription",
        icon: "te_pr_incentive.svg",
      },
      {
        key: "co-travelers",
        label: "Co-Travelers",
        icon: "te_pr_Co-Traveler.svg",
      },
      { key: "incentives", label: "Incentives", icon: "te_pr_incentive.svg" },
      { key: "wishlist", label: "Wishlist", icon: "te_pr_wishlist.svg" },
      { key: "feedback", label: "Feedback", icon: "te_pr_Feedback.svg" },
      {
        key: "rating-review",
        label: rgType === "customer" ? "Add Reviews" : "Rating & Review",
        icon: "te_pr_Rating.svg",
      },
      { key: "settings", label: "Settings", icon: "te_pr_Settings.svg" },
      { key: "logout", label: "Logout", icon: "te_pr_Logout.svg" },
    ];

    const excludeItems = {
      tour_master: ["subscription"],
      customer: ["incentives", "subscription", "co-travelers"],
      vendor: [
        "incentives",
        "dashboard",
        "co-travelers",
        "bookings",
        "incentives",
        "wishlist",
        "feedback",
        "rating-review",
        "settings",
      ],
    };

    const filterItems = sidebarMenu.filter(
      (item) => !(excludeItems[rgType] || []).includes(item.key)
    );

    return isMobile && pathname ? null : (
      <>
        <header className={styles.header_mob}>
          <div className={styles.header_mob__container}>
            <div className={styles.header_mob__logo}>
              <Link title="Logo" key="logo" href="/">
                <img
                  src={`${"/shared/api/media/" +
                    this.props?.data?.siteData?.data?.header?.logo
                    }`}
                  alt="logo"
                />
              </Link>
            </div>
            <button
              className={`${styles.header_mob__menu} ${this.state.sidebarOpen ? styles.hamburger_mob_menuHidden : ""
                }`}
              aria-label="Open menu"
              onClick={this.openSidebar}
            >
              <img src="images/te_hamburger.svg" alt="Menu Icon" />
            </button>
          </div>
        </header>
        {this.props?.data?.user?.accessToken ? (
          this.state.sidebarOpen && (
            <>
              <div
                className={`${styles.sidebar_mob_overlay} ${this.state.isClosing ? styles.sidebar_closing : "sidebar_open"
                  }`}
              ></div>
              <div
                className={`${styles.sidebar_mob} ${this.state.isClosing ? styles.sidebar_closing : "sidebar_open"
                  }`}
                ref={this.sidebarRef}
              >
                <div className={styles.sidebar__profile}>
                  <div className={styles.sidebar__avatar}>
                    <img
                      src={`/shared/api/media/${this.props?.data?.user?.profile_image || "images/userplaceholder.svg"}`}
                      alt={`${this.props?.data?.user?.first_name}`}
                      className={styles.sidebar__avatar_img}
                      onError={this.handleImageError}
                    />
                  </div>
                  <div className={styles.sidebar__info}>
                    <div className={styles.sidebar__name}>
                      {this.state.displayName || this.props?.data?.user?.first_name}
                    </div>
                    {/* <div className={styles.sidebar__role}>Tour Masters</div> */}
                  </div>
                </div>

                <nav className={styles.sidebar__nav}>
                  <ul className={styles.sidebar__menu}>
                    {filterItems.map((item) => (
                      <li
                        key={item.key}
                        className={`${styles.sidebar__item} ${this.state.selectedMenuKey === item.key
                          ? styles.sidebar__item_active
                          : ""
                          }`}
                        onClick={() => {
                          this.setState({ selectedMenuKey: item.key });
                          if (item.key === "logout") {
                            this.handleLogout();
                          } else {
                            window.location.href = `/myprofile?activeTab=${item.key}`;
                          }
                        }}tour_master
                        style={{ cursor: "pointer" }}
                      >
                        <span className={styles.sidebar__icon}>
                          <img src={`images/${item.icon}`} alt={item.label} />
                        </span>
                        <span className={styles.sidebar__label}>
                          {item.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <SidebarVersion styles={styles} />
                </nav>
              </div>
            </>
          )
        ) : (
          <>
            {this.state.sidebarOpen && (
              <>
                <div
                  className={`${styles.sidebar_mob_overlay} ${this.state.isClosing
                    ? styles.sidebar_closing
                    : "sidebar_open"
                    }`}
                ></div>
                <div
                  className={`${styles.sidebar_mob} ${this.state.isClosing
                    ? styles.sidebar_closing
                    : "sidebar_open"
                    }`}
                  ref={this.sidebarRef}
                >
                  <div className={styles.sidebar_mob__header}>
                    <button
                      className={styles.sidebar_mob__close}
                      aria-label="Close sidebar"
                      onClick={this.closeSidebar}
                    >
                      <img src="images/te_BTN_Close.svg" alt="Close" />
                    </button>
                    <div
                      className={styles.sidebar_mob__account}
                      onClick={this.handleLoginRegisterClick}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="images/te_User_Account.svg"
                        alt="Account"
                        className={styles.sidebar_mob__account_icon}
                      />
                      <span className={styles.sidebar_mob__account_text}>
                        Login / Register
                      </span>
                    </div>
                  </div>
                  <div className={styles.sidebar_mob__main}>
                    <ul className={styles.sidebar_mob__nav}>
                      <a href="/holiday/destination">
                        <li className={styles.sidebar_mob__nav_item}>
                          <img
                            src="images/te_Destination.svg"
                            alt="Destinations"
                            className={styles.sidebar_mob__nav_icon}
                          />
                          <span className={styles.sidebar_mob__nav_text}>
                            Destinations
                          </span>
                        </li>
                      </a>
                      <a href="/tourpackages">
                        <li className={styles.sidebar_mob__nav_item}>
                          <img
                            src="images/te_holiday.svg"
                            alt="Holidays"
                            className={styles.sidebar_mob__nav_icon}
                          />
                          <span className={styles.sidebar_mob__nav_text}>
                            Holidays
                          </span>
                        </li>
                      </a>

                      <a href="/holiday/tourmaster">
                        <li className={styles.sidebar_mob__nav_item}>
                          <img
                            src="images/te_tour_master_icon.svg"
                            alt="Tour Masters"
                            className={styles.sidebar_mob__nav_icon}
                          />
                          <span className={styles.sidebar_mob__nav_text}>
                            Tour Masters
                          </span>
                        </li>
                      </a>
                      {/* <li className={styles.sidebar_mob__nav_item}>
                        <img
                          src="images/te_Offer.svg"
                          alt="Offers"
                          className={styles.sidebar_mob__nav_icon}
                        />
                        <span className={styles.sidebar_mob__nav_text}>
                          Offers
                        </span>
                      </li> */}
                    </ul>
                    <div className={styles.sidebar_mob__divider}></div>
                    <ul className={styles.sidebar_mob__actions}>
                      <li
                        className={styles.sidebar_mob__action_item}
                        onClick={() => {
                          commonFunction.redirectTo("/registration", "");
                        }}
                      >
                        <img
                          src="images/te_rightSide_arrow.svg"
                          alt="Become a Tour Master"
                          className={styles.sidebar_mob__action_icon}
                        />
                        <span className={styles.sidebar_mob__action_text}>
                          Become a Tour Master
                        </span>
                      </li>
                      <li
                        className={styles.sidebar_mob__action_item}
                        onClick={() => {
                          commonFunction.redirectTo("/vendor", "");
                        }}
                      >
                        <img
                          src="images/te_rightSide_arrow.svg"
                          alt="Become a Vendor"
                          className={styles.sidebar_mob__action_icon}
                        />
                        <span className={styles.sidebar_mob__action_text}>
                          Become a Vendor
                        </span>
                      </li>
                    </ul>
                    <div className={styles.sidebar_mob__divider}></div>
                    <ul className={styles.sidebar_mob__links}>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/about-us">About tripbutter</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/fnq">FAQs</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/holiday/testimonials">Testimonials</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/holiday/travelarticle">Travel Articles</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/career">Careers</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/contact-us">Contact Us</a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        {this.props?.data?.user?.accessToken ? (
                          <a href="/feedback">Feedback</a>
                        ) : (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleLoginRegisterClick(e);
                            }}
                          >
                            Feedback
                          </a>
                        )}
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleLoginRegisterClick(e);
                          }}
                        >
                          Rate Us
                        </a>
                      </li>
                    </ul>
                    <div className={styles.sidebar_mob__divider}></div>
                    <ul className={styles.sidebar_mob__links}>
                      <li className={styles.sidebar_mob__link_item}>
                        {this.props?.data?.user?.accessToken ? (
                          <a href="/myprofile?activeTab=settings">Settings</a>
                        ) : (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleLoginRegisterClick(e);
                            }}
                          >
                            Settings
                          </a>
                        )}
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/privacy-policy">Privacy Policy </a>
                      </li>
                      <li className={styles.sidebar_mob__link_item}>
                        <a href="/terms-and-conditions">Terms and Conditions</a>
                      </li>
                    </ul>
                    <div className={styles.sidebar_mob__version}>
                      App Version 1.0.0
                    </div>
                  </div>
                </div>
              </>
            )}

            {this.state.showLoginSheet && (
              <div className={styles.login_sheet_overlay}>
                <div className={styles.login_sheet} ref={this.loginSheetRef}>
                  <div className={styles.login_sheet_header}>
                    <span className={styles.login_sheet_title}>
                      <img
                        src="images/te_User_Account.svg"
                        alt="Account"
                        className={styles.login_sheet_icon}
                      />
                      Login / Register
                    </span>
                    <button
                      className={styles.login_sheet_close}
                      onClick={this.closeLoginSheet}
                    >
                      <img src="images/te_btn_black_Close.svg" alt="Close" />
                    </button>
                  </div>
                  <div className={styles.login_sheet_body}>
                    {userTypes.map((item, idx) => (
                      <div key={idx} className={styles.login_sheet_row}>
                        <div className={styles.login_sheet_user_type}>
                          <img
                            src={`images/${item.icon}`}
                            alt={item.role}
                            className={styles.login_sheet_user_icon}
                          />
                          <span className={styles.login_sheet_user_text}>
                            {item.role}
                          </span>
                        </div>
                        <div className={styles.login_sheet_actions}>
                          <span
                            className={styles.login_sheet_action}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (item.role === "Vendor") {
                                this.handleLoginSheetAction("Vendor_login");
                                localStorage.setItem("regis", item.role);
                              } else {
                                this.handleLoginSheetAction("login");
                                localStorage.setItem("regis", item.role);
                              }
                            }}
                          >
                            Login
                          </span>
                          <span className={styles.login_sheet_action_separator}>
                            |
                          </span>
                          <span
                            className={styles.login_sheet_action}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              item.role === "Tour Master"
                                ? commonFunction.redirectTo("/registration", "")
                                : item.role === "Vendor"
                                  ? commonFunction.redirectTo("/vendor", "")
                                  : this.handleLoginSheetAction("register")
                            }
                          >
                            Register
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {this.state.showLogoutPopup && (
          <div
            className={styles.login_sheet_overlay}
            onClick={() => this.setState({ showLogoutPopup: false })}
          >
            <div className={styles.login_sheet} ref={this.loginSheetRef}>
              <div className={styles.login_sheet_header}>
                <span className={styles.login_sheet_title}>Logout</span>
                <button
                  className={styles.login_sheet_close}
                  onClick={() => this.setState({ showLogoutPopup: false })}
                >
                  <img src="images/te_btn_black_Close.svg" alt="Close" />
                </button>
              </div>
              <div className={styles.login_sheet_body}>
                <div className={styles.logout_main_icon}>
                  <img
                    src="images/tb_logout_blue.svg"
                    alt="Logout Icon"
                  />
                </div>
                <p className={styles.logout_popup_text}>
                  Are you sure you want to Logout?
                </p>
                <div className={styles.logout_popup_actions}>
                  <button className={styles.btn_outline} onClick={() => { }}>Yes</button>
                  <button className={styles.btn_fill}
                    onClick={() => this.setState({ showLogoutPopup: false })}
                  >
                    No
                    <img src="images/trightarrow.svg" alt="Close" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

function SidebarVersion({ styles }) {
  return <div className={styles.sidebar__version}>App Version 1.0.0</div>;
}

export default MobileHeader;
